import { Building2, Users, TrendingUp, MapPin } from "lucide-react";

const SocialProof = () => {
  const stats = [
    {
      icon: Users,
      value: "7M",
      label: "adhérents en France"
    },
    {
      icon: Building2,
      value: "5 600",
      label: "salles de sport"
    },
    {
      icon: MapPin,
      value: "1 200",
      label: "membres par salle"
    },
    {
      icon: TrendingUp,
      value: "+7%",
      label: "croissance annuelle"
    }
  ];

  return (
    <section
      id="vision"
      data-testid="social-proof-section"
      className="bg-[#0A0A0A] text-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left Column - Content */}
          <div>
            <p
              data-testid="social-proof-label"
              className="font-body text-sm tracking-[0.2em] uppercase text-[#B89F7C] mb-6"
            >
              Notre Vision
            </p>
            <h2
              data-testid="social-proof-headline"
              className="font-heading text-4xl sm:text-5xl font-light tracking-tight leading-tight mb-8"
            >
              Un nouveau canal
              <br />
              <span className="italic text-[#B89F7C]">d'échantillonnage physique</span>
            </h2>
            <p className="font-body text-lg font-light leading-relaxed text-white/80 mb-8">
              Le Pschitt Français développe un réseau de lieux premium soigneusement 
              sélectionnés. Nous créons un pont entre les marques de parfum 
              et les consommateurs, au moment exact où ils sont le plus réceptifs.
            </p>
{/* Partenariats à venir */}
          </div>

          {/* Right Column - Stats Grid */}
          <div className="grid grid-cols-2 gap-6">
            {stats.map((stat) => (
              <div
                key={stat.label}
                data-testid={`stat-card-${stat.label.toLowerCase().replace(/\s+/g, '-')}`}
                className="border border-white/20 p-8 hover:border-[#B89F7C] transition-colors duration-500"
              >
                <stat.icon
                  strokeWidth={1}
                  size={28}
                  className="text-[#B89F7C] mb-4"
                />
                <p className="font-heading text-4xl lg:text-5xl text-white mb-2">
                  {stat.value}
                </p>
                <p className="font-body text-sm font-light text-white/70">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
